import { EndOfJourneyQuestion } from '../../lib/types/models/end-of-journey-template/end-of-journey-question'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEndOfJourneyQuestions(templateId: number): Promise<EndOfJourneyQuestion[]> {
  return restApiClient
    .url(constructApiUrl(API['end-of-journey-templates'].getQuestions.url, { id: templateId }))
    .get()
}
